import React from "react";

// Helper to display arrays with quantities - handles the new schema structure
const formatArrayWithQuantity = (arr) => {
  if (!Array.isArray(arr) || !arr.length) return "Not specified";

  return arr
    .map((item) => {
      if (item?.optionId) {
        const name = item.optionId?.name || item.optionId;
        const quantity = item.quantity;
        return quantity ? `${name} (Qty: ${quantity})` : name;
      }
      return item?.name || item;
    })
    .join(", ");
};

// Helper to display single values - handles both populated objects and strings
const formatSingleValue = (value) => {
  if (!value) return "Not specified";
  return value?.name || value;
};

// Helper to format expiry days
const formatExpiry = (days) => {
  if (days === undefined || days === null) return "Not specified";
  if (days === 0) return "0 days";
  if (days === 1) return "1 day";
  return `${days} days`;
};

const CommunityTriggerView = ({ data }) => {
  return (
    <div className="space-y-4 p-4">
      <div className="space-y-1">
        <h4 className="font-semibold">Trigger</h4>
        <p>{data?.trigger || "Not specified"}</p>
      </div>

      <div className="space-y-1">
        <h4 className="font-semibold">Type</h4>
        <p>{formatSingleValue(data?.type)}</p>
      </div>

      <div className="space-y-1">
        <h4 className="font-semibold">Vessel</h4>
        <p>{formatArrayWithQuantity(data?.vessel)}</p>
      </div>

      <div className="space-y-1">
        <h4 className="font-semibold">Message</h4>
        <p>{data?.message || "Not specified"}</p>
      </div>

      <div className="space-y-1">
        <h4 className="font-semibold">Prompt</h4>
        <p>{data?.prompt || "Not specified"}</p>
      </div>

      <div className="space-y-1">
        <h4 className="font-semibold">Receiver</h4>
        <p>{formatArrayWithQuantity(data?.receiver)}</p>
      </div>

      <div className="space-y-1">
        <h4 className="font-semibold">Expiry</h4>
        <p>{formatExpiry(data?.expiry)}</p>
      </div>
    </div>
  );
};

export default CommunityTriggerView;
